import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FormTitle = styled.p`
  font-family: BiotifMedium;
  color: #1c1b3a;
  font-size: 22px;
  margin: 0;
  text-align: center;
`;

export const CloseIcon = styled.img`
  height: auto;
  width: 14px;
  cursor: pointer;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  background-color: #fff;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  // height: 235px;
  gap: 10px;
  padding: 20px;
  background-color: #fff;
  border-radius: 15px;
`;

export const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
`;

export const FullRow = styled.div`
  grid-column: 1 / -1;
  display: flex;
  gap: 20px;
`;

// export const Field = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 6px;

//   label {
//     font-size: 13px;
//     color: #6b6f82;
//     font-family: BiotifMedium;
//   }
// `;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;

  label {
    font-size: 13px;
    color: #6b6f82;
    font-family: BiotifMedium;
  }
`;

export const SectionTitle = styled.div`
  grid-column: 1 / -1;
  font-size: 14px;
  font-family: BiotifMedium;
  color: #1c1b3a;
  padding-top: 10px;
  border-top: 1px solid #e0e3eb;
`;

export const SearchDropdown = styled.div`
  position: absolute;
  top: 70px; /* same as employee example */
  left: 0;
  width: 100%;
  z-index: 1000;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 7px;
  max-height: 220px;
  overflow-y: auto;
`;

export const SearchItem = styled.div`
  padding: 10px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background-color: #f3f4f8;
  }
`;

export const LoadingText = styled.div`
  padding: 10px;
  font-size: 13px;
  color: #6b6f82;
`;

export const DropdownWrapper = styled.div`
  width: 100%;
  margin-top: 5px;

  /* target internal dropdown container */
  > div {
    height: 38px;
    min-height: 38px;
  }

  /* optional: align text vertically */
  button,
  input,
  div[class*='control'] {
    min-height: 38px;
    height: 38px;
  }
  select {
    min-width: 183px;
  }
`;
